export { default } from './CardsColumn';
export type {
  IPrismicCardsColumnItem,
  IPrismicCardsColumnPrimary,
} from './types';
